import TableModel from './table-stats.model'

let storeContent = utils.generateStore({
   TableModel,
   tables: [],
   selected_tables: [],
   show_delete_confirmation: false
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async updateEventDashboard(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'update',
                  data: {
                     id: ctx.getters.selected_tables[0]._id,
                     record: {
                        dashboard: data.dashboard,
                     }
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "table",
                  }
               })

               await ctx.dispatch('fetchEventTables')
               await payload.ref.resetForms()
               ctx.commit('show_edit_modal', false)
               $notify('success', 'Dashboard Updated', `Table ${res.result.data.name} successfully updated dashboard.`, 5)
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteEvent(ctx,payload) {
         try {
            let data = payload.ref.form_data_
            
            if(data.name !== ctx.getters.selected_tables[0].name){
               $notify('error', 'Match Error', `The name provided does not match the table name.`, 5)
               return false
            }
            
            ctx.commit('loading', true)
            let res = await api.fetchEndpoint({
               resource: 'table',
               action: 'delete:table',
               data: {
                  table_id: ctx.getters.selected_tables[0]._id,
               },
               meta_data: {}
            })

            await payload.ref.resetForms()
            await ctx.dispatch('fetchEventTables')
            ctx.commit('show_delete_confirmation', false)
            $notify('success', 'Table Deleted', `<b>${res.result.table.name}</b> Table and <b>${res.result.field_count}</b> fields successfully deleted.`, 5)

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async handleActions(ctx, payload) {
         try {
            if (payload.action === 'table:attach_dashboard') {
               Event.$emit('loader:show',true)
               let TableModel = ctx.getters.TableModel
               TableModel.forms.attach_dashboard.data = payload.rows[0]
               
               ctx.commit('TableModel', TableModel)
               ctx.commit('show_edit_modal', true)
               ctx.commit('selected_tables', payload.rows)
               Event.$emit('loader:show',false)
            } else if (payload.action === 'table:view_dashboard') {
               if(payload.rows[0].dashboard){
                  ctx.getters.router.push({name: 'Dashboards-View_Dashboard', params: {dashboard_id: payload.rows[0].dashboard}})
               }else{
                  $notify('warning', 'Configure Dashboard', `This event has no dashboard configured`, 5)
               }
            }
            
         } catch (error) {
            Event.$emit('loader:show',false)
         }
      },
      async fetchTableDatabaseData(ctx,payload) {
         try {
            // Fetch Schema
            await api.fetchEndpointSecure({
               resource: 'table',
               action: 'get:data',
               data: {
                  table_id: payload.table._id
               },
               meta_data: {}
            })

            $notify('success', 'Fetching Data', `Table ${payload.table.alias || payload.table.alias} data is being remotely fetched. You will receive a notification once this process is complete`, 10)
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {
                  rules: {}
               },
               meta_data: {service: "analytics",collection: "dashboard"}
            })


            let Model = utils.appendSelectData({
               Model: ctx.getters.TableModel,
               forms: ['attach_dashboard'],
               model: 'dashboard',
               label: 'name',
               dataField: '_id',
               data: res.result.records
            })
            ctx.commit('TableModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchTableFormFields(ctx,table) {
         try {
            // Fetch Table Fields
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        table_code: table
                     }
                  }
               },
               meta_data: { service: "analytics", collection: "field",}
            })


            let Model = utils.appendSelectData({
               Model: ctx.getters.TableModel,
               forms: ['editTable'],
               model: 'unique_field',
               label: 'name',
               dataField: 'name',
               data: res.result.records
            })
            ctx.commit('TableModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchEventTables(ctx) {
         try {
            let res = await api.fetchEndpoint({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {
                        db_schema: "events"
                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "table",
               }
            })

            ctx.commit('tables', res.result.records);
            Event.$emit('loader:show',false)
         } catch (err) {
            Event.$emit('loader:show',false)
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchFormData')
            await ctx.dispatch('fetchEventTables')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};